import { FC, useState } from 'react';

import {
  Button,
  ButtonCore,
  Checkbox,
  Col,
  Form,
  InputCore,
  InputPasswordCore,
  Row,
} from '@components';

import type { IRegister } from '@coreAuth/type';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import styles from './index.module.scss';
import { useGoogleAuthFlow } from 'src/hooks/useOAuth';
import { FcGoogle } from 'react-icons/fc';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@store';
import { useGoogleLogin } from '@react-oauth/google';

interface ISignupTagProp {
  authCallback: (data: IRegister) => void;
  onHaveAcc: () => void;
  loading: boolean;
  onGoogleAuthSuccess?: () => void;
}

interface IResponse {
  Status: boolean;
  ErrorMessage?: any;
  SessionId: string;
  user_info: Userinfo;
}
interface Userinfo {
  UserID: number;
  UserName: string;
  Gender?: any;
  UserTypeTitle: string;
  UserTypeID: number;
  Mobile?: any;
  BirthDate?: any;
  FirstName?: any;
  LastName?: any;
  fullName: string;
  BusinessModelID: number;
  BusinessModelTitle: string;
  StartDate: string;
  ExpireDate: string;
  Photo?: any;
}

const SignupTag: FC<ISignupTagProp> = ({
  authCallback,
  onHaveAcc,
  loading,
  onGoogleAuthSuccess,
}) => {
  const navigate = useNavigate();
  const { setAuthState } = useStore();
  const [form] = Form.useForm();
  const [rulesNotChecked, setRulesNotChecked] = useState<boolean>(true);
  const handleCheckRules = (e: CheckboxChangeEvent) => {
    setRulesNotChecked(!e.target.checked);
  };

  const loginGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log(tokenResponse);

      fetch('https://app.tadatoon.com/api/trust/google/start2', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: tokenResponse.access_token,
        }),
      })
        .then((res) => res.json())
        .then((data: IResponse) => {
          console.log('Backend response:', data);
          localStorage.setItem('sessionId', data.SessionId);
          localStorage.setItem('userId', String(data.user_info.UserID));
          setAuthState(data.SessionId, String(data.user_info.UserID));
          navigate('/dashboard', { replace: true });
        });
    },
  });
  return (
    <div className={styles['login_reg_container']}>
      <div className={styles['title']}>
        <h1 className="text-pink title">Sign up</h1>
      </div>
      <Form
        form={form}
        className={styles['log_reg_form']}
        labelCol={{ span: 24 }}
        onFinish={authCallback}>
        <div>
          <Row gutter={40}>
            <Col xs={24}>
              <Form.Item
                label="Email"
                name="username"
                rules={[
                  { required: true, message: '' },
                  {
                    pattern: new RegExp(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/),
                    message: 'Email is incorrect',
                  },
                ]}>
                <InputCore />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: '' },
                  {
                    min: 8,
                    message: 'Your password must be at least 8 characters',
                  },
                ]}>
                <InputPasswordCore />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                label="Confirm Password"
                name="confirmPassword"
                rules={[
                  { required: true, message: '' },
                  ({ getFieldValue }) => ({
                    validator(_rule, value) {
                      if (value !== getFieldValue('password')) {
                        return Promise.reject('Passwords did not match');
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}>
                <InputPasswordCore />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item name="rules">
                <Checkbox onChange={handleCheckRules}>
                  I agree to the Privacy Policy and Terms of Service
                </Checkbox>
              </Form.Item>
            </Col>
            <Col xs={24}>
              <div
                className={styles['switch_forms']}
                onClick={() => onHaveAcc()}>
                <span>Already have an account ? </span>
                <span className={styles['link']}>Login here !</span>
              </div>
            </Col>
          </Row>
        </div>

        <div className={styles['button_card']}>
          <Button
            loading={loading}
            type="primary"
            htmlType={'submit'}
            block
            disabled={rulesNotChecked}>
            Sign up
          </Button>
        </div>
        <div className={styles['button_card']}>
          <Button className={styles.googleButton} onClick={() => loginGoogle()}>
            <FcGoogle size={20} />
            <span>Sign in with Google</span>
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SignupTag;
